/* MOLORA Geschenkset v1.5 (27.10.2026)
   Komplett-Geschenkset im Konfigurator: Teppich + Erster Name + Symbol + Geschenkschleife
   + Tasbih + Mini-Koran. DE: 49,99 statt 56,94 (Ersparnis 6,95).

   Geladen aus snippets/mlr-set.liquid, NUR auf der Produktseite des personalisierten
   Gebetsteppichs. Erweitert window.mlrKern von aussen, ohne molora-kern.js anzufassen.

   A/B-TEST (v1.1): Besucher werden 50/50 aufgeteilt (Cookie mlr_ab_set, 90 Tage).
     A = bisherige Produktseite (kein Set, keine schwebende Vorschau, keine Angebotsleiste)
     B = Set-Karte mit Bild + schwebende Vorschau + Angebotsleiste
   Zum Ansehen erzwingen: ?mlr_ab=A bzw. ?mlr_ab=B (setzt das Cookie um).
   Messung: Warenkorb-Attribut _mlr_ab_set (landet in der Bestellung), Clarity-Tag
   ab_geschenkset, dataLayer-Event mlr_ab (GA4).

   B-Funktionen:
     1. K.setInfo() / K.calcTotal()-Override (Set-Preis im Preisblock)
     2. Set-Karte oben in Schritt 3 mit Live-Bild (Teppich in gewaehlter Farbe + Name + Extras)
     3. Preisblock: Streichpreis + Badge, Sticky-ATC: Angebotszeile
     4. /cart/add.js: bei komplettem Set bekommt der Teppich `_mlr_set` = "1"
        (erst damit gibt die Function molora-functions Block C den Rabatt frei)
     5. Mobile: schwebende Vorschau oben rechts (Kopie von Galeriebild + Namens-Canvas), sobald ein
        Name eingegeben ist und die Galerie aus dem Bild scrollt; weg ab Schritt 3 (Extras)
     6. Set-Button waehlt das Herz vor, wenn noch kein Symbol gewaehlt ist (sichtbar, aenderbar)

   SET_RATIO muss zu SET_RATIO in molora-functions/extensions/mlr-upsell-ladder/src/
   cart_lines_discounts_generate_run.js passen (6,95 / 31,95). Beide Stellen zusammen aendern.
*/
(function(){
  'use strict';
  if (window.__mlrSetInit) return;
  window.__mlrSetInit = true;

  /* ---------- A/B-Zuteilung ---------- */
  function readCookie(n){ var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function writeCookie(n, v){ document.cookie = n + '=' + v + '; path=/; max-age=' + (90 * 86400) + '; SameSite=Lax'; }
  var AB = null;
  try {
    var q = (location.search.match(/[?&]mlr_ab=([AB])/) || [])[1];
    AB = q || readCookie('mlr_ab_set');
    if (AB !== 'A' && AB !== 'B') AB = Math.random() < 0.5 ? 'A' : 'B';
    writeCookie('mlr_ab_set', AB);
  } catch (e) { AB = 'B'; }
  window.mlrSetAB = AB;

  function report(){
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'mlr_ab', ab_test: 'geschenkset', ab_variant: AB }); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('set', 'ab_geschenkset', AB); } catch (e) {}
    try {
      if (sessionStorage.getItem('mlr_ab_set_sent') !== AB) {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _mlr_ab_set: AB } }) })
          .then(function(){ try { sessionStorage.setItem('mlr_ab_set_sent', AB); } catch (e) {} });
      }
    } catch (e) {}
  }
  if (document.readyState === 'complete') setTimeout(report, 1500);
  else window.addEventListener('load', function(){ setTimeout(report, 1500); });

  if (AB === 'A') return; /* Variante A: alte Produktseite, nichts anfassen */

  var SET_RATIO = 6.95 / 31.95;
  var dataEl = document.getElementById('mlr-set-data');
  var T = {};
  try { T = JSON.parse(dataEl ? dataEl.textContent : '{}') || {}; } catch (e) { T = {}; }

  /* Wo steht der Name auf dem Teppich? Bounding-Box der gezeichneten Pixel im Namens-Canvas,
     als Anteil 0..1 (cx, cy). null, wenn nichts gezeichnet ist. */
  function nameBox(){
    var nc = document.getElementById('mlr-name-canvas');
    if (!nc || !nc.width || !nc.height) return null;
    try {
      var w = nc.width, h = nc.height, d = nc.getContext('2d').getImageData(0, 0, w, h).data;
      var step = Math.max(1, Math.round(w / 260)), x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y += step) for (var x = 0; x < w; x += step) {
        if (d[(y * w + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      if (x1 < 0) return null;
      return { cx: (x0 + x1) / 2 / w, cy: (y0 + y1) / 2 / h, bw: (x1 - x0) / w, bh: (y1 - y0) / h };
    } catch (e) { return null; }
  }

  function tpl(s, map){ return String(s || '').replace(/\{(\w+)\}/g, function(_, k){ return map[k] != null ? map[k] : ''; }); }

  function boot(){
    var K = window.mlrKern;
    if (!K || !K.state) { window.addEventListener('mlr:ready', boot, { once: true }); return; }
    if (K.__setPatched) return;
    K.__setPatched = true;

    /* ---------- 1. Set-Logik ---------- */
    K.setInfo = function(){
      var s = this._state;
      if (!s) return null;
      var symKey = s.symbol && s.symbol.productId ? s.symbol.key : 'herz';
      var parts = [
        { k: 'name',       ok: !!(s.name && String(s.name).trim()), p: this.priceOf('name') },
        { k: 'symbol',     ok: !!(s.symbol && s.symbol.productId),   p: this.priceOf(symKey) },
        { k: 'geschenk',   ok: !!s.geschenk,                         p: this.priceOf('geschenk') },
        { k: 'tasbih',     ok: !!s.tasbih,                           p: this.priceOf('tasbih') },
        { k: 'mini_koran', ok: !!s.mini_koran,                       p: this.priceOf('mini_koran') }
      ];
      var sum = 0;
      parts.forEach(function(x){ sum += x.p; });
      var saving = Math.round(sum * SET_RATIO * 100) / 100;
      var rug = this.priceOf('teppich');
      var missing = parts.filter(function(x){ return !x.ok; }).map(function(x){ return x.k; });
      return { complete: missing.length === 0 && saving > 0, missing: missing, saving: saving, full: rug + sum, setPrice: rug + sum - saving };
    };

    var origCalc = K.calcTotal;
    K.calcTotal = function(){
      var t = origCalc.call(this);
      var si = this.setInfo();
      if (si && si.complete) t = Math.round((t - si.saving) * 100) / 100;
      return t;
    };

    /* ---------- 4. Stempel beim Hinzufuegen ---------- */
    if (window.fetch && !window.__mlrSetFetch) {
      window.__mlrSetFetch = true;
      var _f = window.fetch;
      window.fetch = function(input, init){
        try {
          var url = (input && input.url) || input || '';
          if (typeof url === 'string' && url.indexOf('/cart/add') >= 0 && init && typeof init.body === 'string') {
            var si = K.setInfo();
            if (si && si.complete) {
              var body = JSON.parse(init.body);
              if (body && Array.isArray(body.items)) {
                body.items.forEach(function(it){
                  if (it && it.properties && it.properties['_has_gpo'] === '1') it.properties['_mlr_set'] = '1';
                });
                init = Object.assign({}, init, { body: JSON.stringify(body) });
              }
            }
          }
        } catch (e) {}
        return _f.call(this, input, init);
      };
    }

    /* ---------- 2. Set-Karte mit Live-Bild ---------- */
    var TOG = { geschenk: 'mlr-geschenk-tog', tasbih: 'mlr-tasbih-tog', mini_koran: 'mlr-mini-koran-tog' };
    function togImg(id){
      var t = document.getElementById(id), row = t;
      for (var i = 0; i < 5 && row && !row.querySelector('img'); i++) row = row.parentElement;
      var im = row && row.querySelector('img');
      return im ? (im.currentSrc || im.src) : '';
    }

    var step3 = document.querySelector('[data-mlr-step="3"]');
    var card = null, thumbImg = null, thumbCanvas = null, autoSym = false;
    if (step3) {
      card = document.createElement('div');
      card.className = 'mlr-set-card';
      card.id = 'mlr-set-card';
      var extras = ['geschenk', 'tasbih', 'mini_koran'].map(function(k){
        var src = togImg(TOG[k]);
        return src ? '<span class="mlr-set-x"><img src="' + src + '" alt="" loading="lazy"></span>' : '';
      }).join('');
      card.innerHTML =
        '<div class="mlr-set-ribbon">🎁 ' + (T.eyebrow || '') + '</div>' +
        '<div class="mlr-set-body">' +
          '<div class="mlr-set-visual" aria-hidden="true">' +
            '<div class="mlr-set-rug"><div class="mlr-set-zoom" data-set="zoom"><img alt="" data-set="rugimg"><canvas data-set="rugname"></canvas></div><canvas class="mlr-flat" data-set="flat"></canvas></div>' +
            '<div class="mlr-set-xs">' + extras + '</div>' +
          '</div>' +
          '<div class="mlr-set-main">' +
            '<div class="mlr-set-title">' + (T.title || '') + '</div>' +
            '<div class="mlr-set-prices"><strong class="mlr-set-price" data-set="price"></strong> <s class="mlr-set-full" data-set="full"></s></div>' +
            '<div class="mlr-set-tags"><span class="mlr-set-save" data-set="save"></span>' + (T.ship ? ' <span class="mlr-set-ship">' + T.ship + '</span>' : '') + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="mlr-set-status" data-set="status"></div>' +
        '<button type="button" class="mlr-set-btn" data-set="btn"></button>';
      var anchor = step3.querySelector('.mlr-section-card');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(card, anchor);
      else step3.appendChild(card);
      thumbImg = card.querySelector('[data-set="rugimg"]');
      thumbCanvas = card.querySelector('[data-set="rugname"]');

      card.querySelector('[data-set="btn"]').addEventListener('click', function(){
        K.updateState({ geschenk: true, tasbih: true, mini_koran: true });
        /* Set enthaelt ein Symbol: noch keins gewaehlt -> Herz vorwaehlen (sichtbar, aenderbar) */
        var st0 = K.state || {};
        if (!(st0.symbol && st0.symbol.productId)) {
          var herz = document.querySelector('.mlr-sym-card[data-sym="herz"]');
          if (herz) { autoSym = true; herz.click(); render(); }
        }
        var si = K.setInfo();
        if (si && !si.complete && (si.missing.indexOf('name') >= 0 || si.missing.indexOf('symbol') >= 0)) goToName();
      });
      card.addEventListener('click', function(e){
        if (e.target.closest('.mlr-set-visual')) { goToName(); return; }
        if (e.target.closest('[data-set="gosym"]')) {
          e.preventDefault();
          var row = document.getElementById('mlr-sym-row');
          if (row) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var a = e.target.closest('[data-set="goto"]');
        if (!a) return;
        e.preventDefault();
        goToName();
      });
    }

    /* Kopie der Live-Vorschau (Galeriebild + Namens-Canvas) in ein eigenes Element zeichnen.
       Bewusst eine KOPIE: das Original bleibt in der Galerie, deren Skript den Canvas bei
       resize neu vermisst (iOS feuert resize beim Scrollen). opts.zoom: [min,max] oder null. */
    function paintCopy(zoomEl, imgEl, cvEl, opts){
      var rug = document.getElementById('mlr-rug-img');
      var nc = document.getElementById('mlr-name-canvas');
      var src = rug && (rug.currentSrc || rug.src);
      if (!src) { var ci = K._colorImages && K._colorImages[K._colorKey]; src = ci && ci[0]; }
      /* vergroessert gezeigt -> Foto in 1600 px statt 800 px laden */
      if (src && opts && opts.zoom) src = String(src).replace(/([?&]width=)\d+/, '$11600');
      if (src && imgEl.getAttribute('src') !== src) imgEl.src = src;
      if (!nc || !rug) return;
      var cs = getComputedStyle(nc);
      var show = cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0;
      cvEl.style.display = show ? '' : 'none';
      zoomEl.style.transform = '';
      if (!show) return;
      var ri = rug.getBoundingClientRect(), rc = nc.getBoundingClientRect();
      if (!ri.width || !rc.width) return;
      cvEl.style.left = ((rc.left - ri.left) / ri.width * 100) + '%';
      cvEl.style.top = ((rc.top - ri.top) / ri.height * 100) + '%';
      cvEl.style.width = (rc.width / ri.width * 100) + '%';
      cvEl.style.height = (rc.height / ri.height * 100) + '%';
      var nb = opts && opts.zoom ? nameBox() : null;
      var f = 1;
      if (nb) f = Math.max(opts.zoom[0], Math.min(opts.zoom[1], 0.75 / Math.max(nb.bw * rc.width / ri.width, 0.05)));
      /* Name in eigener Aufloesung neu zeichnen (scharf auch vergroessert), sonst Pixel kopieren */
      var shown = zoomEl.clientWidth * (rc.width / ri.width);
      var mult = (shown / Math.max(1, nc.clientWidth || rc.width)) * f * (window.devicePixelRatio || 1);
      var fresh = false;
      try { fresh = !!(window.mlrStick && window.mlrStick.paintInto && window.mlrStick.paintInto(cvEl, mult)); } catch (e) { fresh = false; }
      if (!fresh) {
        if (cvEl.width !== nc.width) cvEl.width = nc.width;
        if (cvEl.height !== nc.height) cvEl.height = nc.height;
        try { var c2 = cvEl.getContext('2d'); c2.setTransform(1, 0, 0, 1, 0, 0); c2.clearRect(0, 0, cvEl.width, cvEl.height); c2.drawImage(nc, 0, 0); } catch (e) {}
      }
      if (!nb) return;
      /* auf den Namen zoomen und ihn in die Mitte schieben, ohne leere Raender */
      var px = (rc.left - ri.left + nb.cx * rc.width) / ri.width;
      var py = (rc.top - ri.top + nb.cy * rc.height) / ri.height;
      var tx = Math.min(0, Math.max(1 - f, 0.5 - px * f)) * 100;
      var ty = Math.min(0, Math.max(1 - f, 0.5 - py * f)) * 100;
      zoomEl.style.transformOrigin = '0 0';
      zoomEl.style.transform = 'translate(' + tx.toFixed(1) + '%,' + ty.toFixed(1) + '%) scale(' + f.toFixed(2) + ')';
    }
    var drawT = null, floatPaint = null;
    function drawThumb(){
      clearTimeout(drawT);
      drawT = setTimeout(function(){
        if (thumbImg) {
          /* Mit Name: flache Stickvorschau (gross + scharf). Ohne Name / Arabisch: Fotoausschnitt. */
          var flat = card.querySelector('[data-set="flat"]'), z = card.querySelector('[data-set="zoom"]');
          var ok = false;
          try { ok = !!(window.mlrStick && window.mlrStick.paintFlat && window.mlrStick.paintFlat(flat, 104, 104, window.devicePixelRatio || 1)); } catch (e) { ok = false; }
          flat.style.display = ok ? 'block' : 'none';
          z.style.visibility = ok ? 'hidden' : '';
          if (!ok) paintCopy(z, thumbImg, thumbCanvas, { zoom: [1.6, 4.5] });
        }
        if (floatPaint) floatPaint();
      }, 140);
    }
    var rugEl = document.getElementById('mlr-rug-img');
    if (rugEl && window.MutationObserver) new MutationObserver(drawThumb).observe(rugEl, { attributes: true, attributeFilter: ['src', 'srcset', 'style', 'class'] });

    function goToName(){
      var input = document.getElementById('mlr-name-in');
      if (!input) return;
      var name = K.state && K.state.name && String(K.state.name).trim();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!name) setTimeout(function(){ try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 450);
    }

    /* ---------- 3. Preisblock + Sticky ---------- */
    var priceP = document.getElementById('mlr-live-preis');
    var setTag = null;
    if (priceP) {
      setTag = document.createElement('span');
      setTag.className = 'mlr-set-pricetag';
      setTag.hidden = true;
      priceP.appendChild(setTag);
    }
    var stickyInfo = document.querySelector('#mlr-sticky-atc .mlr-sticky-atc__info');
    var stickyLine = null;
    if (stickyInfo) {
      stickyLine = document.createElement('button');
      stickyLine.type = 'button';
      stickyLine.className = 'mlr-set-sticky';
      stickyInfo.appendChild(stickyLine);
      stickyLine.addEventListener('click', function(){
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function render(){
      var si = K.setInfo();
      if (!si) return;
      var s = K.state || {};
      Object.keys(TOG).forEach(function(k){
        var el = document.getElementById(TOG[k]);
        if (el) el.classList.toggle('mlr-on', !!s[k]);
      });
      var fm = { set: K.fmt(si.setPrice), full: K.fmt(si.full), save: K.fmt(si.saving) };
      if (card) {
        card.classList.toggle('is-complete', si.complete);
        card.querySelector('[data-set="price"]').textContent = fm.set;
        card.querySelector('[data-set="full"]').textContent = fm.full;
        card.querySelector('[data-set="save"]').textContent = tpl(T.save, fm);
        var st = card.querySelector('[data-set="status"]');
        if (si.complete) {
          st.innerHTML = '<span class="mlr-set-ok">✓</span> ' + tpl(T.complete, fm) +
            (autoSym && s.symbol && s.symbol.key === 'herz' && T.sym_auto ? '<br><a href="#" data-set="gosym">' + T.sym_auto + '</a>' : '');
        } else {
          var names = si.missing.map(function(k){ return (T.parts && T.parts[k]) || k; }).join(' · ');
          var needPerso = si.missing.indexOf('name') >= 0 || si.missing.indexOf('symbol') >= 0;
          st.innerHTML = tpl(T.missing, { list: names }) + (needPerso ? ' <a href="#" data-set="goto">' + (T.goto || '') + '</a>' : '');
        }
        var btn = card.querySelector('[data-set="btn"]');
        var extrasOn = !!(s.geschenk && s.tasbih && s.mini_koran);
        btn.textContent = si.complete ? ('✓ ' + (T.btn_done || '')) : (T.btn || '');
        btn.classList.toggle('is-done', si.complete);
        btn.hidden = extrasOn && !si.complete;
      }
      if (setTag) {
        setTag.hidden = !si.complete;
        setTag.innerHTML = '<s>' + fm.full + '</s> <span class="mlr-set-badge">' + tpl(T.badge, fm) + '</span>';
        var cmp = document.querySelectorAll('#mlr-live-preis [data-mlr-compare], #mlr-live-preis .mlr-price-badge');
        cmp.forEach(function(el){ el.style.display = si.complete ? 'none' : ''; });
      }
      if (stickyLine) {
        stickyLine.textContent = si.complete ? tpl(T.sticky_done, fm) : tpl(T.sticky_offer, fm);
        stickyLine.classList.toggle('is-done', si.complete);
      }
      drawThumb();
    }

    ['mlr:stateChange', 'mlr:priceUpdate', 'mlr:colorChange'].forEach(function(ev){ window.addEventListener(ev, render); });
    render();
    setTimeout(drawThumb, 800);
    try { K._emit('priceUpdate', { total: K.calcTotal() }); } catch (e) {}

    /* ---------- 5. Schwebende Vorschau (Mobile) ---------- */
    floatPreview(K, paintCopy, function(fn){ floatPaint = fn; });
  }

  /* Schwebende Vorschau (nur Mobile): erscheint erst, wenn ein Name eingegeben ist und die
     Galerie aus dem Bild gescrollt ist; verschwindet, sobald Schritt 3 (Extras) kommt. */
  function floatPreview(K, paintCopy, setPaint){
    var host = document.getElementById('mlr-vorschau-wrap');
    var step3 = document.querySelector('[data-mlr-step="3"]');
    if (!host) return;
    var KEY = 'mlr_float_closed';
    var closed = false;
    try { closed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    var fl = document.createElement('div');
    fl.id = 'mlr-float';
    fl.className = 'mlr-float';
    fl.setAttribute('aria-hidden', 'true');
    fl.innerHTML = '<div class="mlr-float__inner"><div class="mlr-float__zoomer"><img alt=""><canvas></canvas></div><canvas class="mlr-flat"></canvas></div><div class="mlr-float__tap"></div>' +
      '<button type="button" class="mlr-float__btn mlr-float__close" aria-label="' + (T.float_close || 'Close') + '">×</button>' +
      '<button type="button" class="mlr-float__btn mlr-float__zoom" aria-label="' + (T.float_zoom || 'Zoom') + '">' +
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg></button>';
    document.body.appendChild(fl);
    var inner = fl.querySelector('.mlr-float__inner');
    var zoomer = fl.querySelector('.mlr-float__zoomer');
    var img = zoomer.querySelector('img'), cv = zoomer.querySelector('canvas');
    var on = false, big = false;

    function paint(){
      if (!on) return;
      var rug = document.getElementById('mlr-rug-img');
      var ratio = rug && rug.clientWidth ? rug.clientHeight / rug.clientWidth : 1;
      var w = big ? Math.min(window.innerWidth - 24, 420) : 178;
      fl.classList.toggle('is-big', big);
      var flat = inner.querySelector('.mlr-flat'), ok = false;
      {
        /* klein und gross: flache Stickvorschau (das Teppichfoto zeigt den Namen nur winzig) */
        var h = Math.round(w * 0.62);
        inner.style.width = w + 'px'; inner.style.height = h + 'px';
        try { ok = !!(window.mlrStick && window.mlrStick.paintFlat && window.mlrStick.paintFlat(flat, w, h, window.devicePixelRatio || 1)); } catch (e) { ok = false; }
      }
      flat.style.display = ok ? 'block' : 'none';
      zoomer.style.visibility = ok ? 'hidden' : '';
      if (ok) return;
      inner.style.width = w + 'px';
      inner.style.height = Math.round(w * (ratio || 1)) + 'px';
      paintCopy(zoomer, img, cv, big ? null : { zoom: [1.8, 4.5] });
    }
    setPaint(paint);
    function hasName(){ var s = K.state || {}; return !!(s.name && String(s.name).trim()); }
    var ticking = false;
    function check(){
      ticking = false;
      var want = false;
      if (!closed && window.innerWidth < 750 && hasName() && !document.body.classList.contains('mlr-drawer-open')) {
        var hr = host.getBoundingClientRect();
        var s3 = step3 ? step3.getBoundingClientRect() : null;
        want = hr.bottom < 40 && (!s3 || s3.top > window.innerHeight * 0.3);
      }
      if (want === on) return;
      on = want;
      if (!on) big = false;
      fl.classList.toggle('is-on', on);
      if (on) paint();
    }
    function onScroll(){ if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    ['mlr:stateChange', 'mlr:colorChange'].forEach(function(ev){ window.addEventListener(ev, onScroll); });
    new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    function toggleBig(){ big = !big; paint(); }
    fl.querySelector('.mlr-float__tap').addEventListener('click', toggleBig);
    fl.querySelector('.mlr-float__zoom').addEventListener('click', toggleBig);
    fl.querySelector('.mlr-float__close').addEventListener('click', function(){
      closed = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      onScroll();
    });
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
